import { createElement } from 'react';
import { GetCompletionToastTID } from '../utils/completionToast.utils';
import { PersistentToastContent } from '../utils/PersistentToastContent';
function showSelfDismissing(showPersistentToast, build, onShown) {
    const handle = {
        rawDismiss: ()=>{},
        forget: ()=>{}
    };
    const dismiss = ()=>{
        handle.rawDismiss();
        handle.forget();
    };
    handle.rawDismiss = showPersistentToast(build(dismiss));
    handle.forget = onShown(dismiss);
}
function buildPersistentAction(action, runtime, testId) {
    switch(action.kind){
        case 'open-url':
            return {
                label: action.label,
                biName: action.biName,
                testId,
                run: ()=>runtime.openNewTab(action.url)
            };
        case 'retry':
            return {
                label: action.label,
                biName: action.biName,
                testId,
                run: ()=>runtime.retry(action.relationshipId, {
                        previousJobId: action.previousJobId
                    })
            };
        case 'open-drawer':
            if (!runtime.isDrawerAvailable) return null;
            return {
                label: action.label,
                biName: action.biName,
                testId,
                run: runtime.openDrawer
            };
    }
}
export function emitPersistent(payload, closeLabel, runtime, showPersistentToast, onShown) {
    const { CompletionToastTID } = GetCompletionToastTID();
    const closeBiName = 'tasks_completion_toast_close';
    const persistentAction = buildPersistentAction(payload.action, runtime, CompletionToastTID.Action());
    showSelfDismissing(showPersistentToast, (dismiss)=>createElement(PersistentToastContent, {
            type: payload.kind,
            message: payload.message,
            action: persistentAction != null ? {
                actionLabel: persistentAction.label,
                biName: persistentAction.biName,
                onAction: ()=>{
                    dismiss();
                    persistentAction.run();
                }
            } : undefined,
            closeLabel,
            closeBiName,
            testId: payload.testId,
            onClose: dismiss
        }), onShown);
}
export function runAction(action, runtime) {
    switch(action.kind){
        case 'open-url':
            runtime.openNewTab(action.url);
            return;
        case 'retry':
            runtime.retry(action.relationshipId, {
                previousJobId: action.previousJobId
            });
            return;
        case 'open-drawer':
            runtime.openDrawer();
            return;
    }
}
